<div class="container">
  <!-- DURAÇÃO -->
  <div class="indicador duracao">
    <div class="indicador-text">
      {{ "ROUTE_REPORT.SUMMARY.DURATION.DURATION" | translate }}
    </div>
    <div class="bars" *ngIf="loaded; else skeletonDuracao">
      <!-- Planejado -->
      <div class="bar-row">
        <div class="bar-container">
          <div class="bar planejado-bar" [ngStyle]="{ width: duracaoPlanejado }">
            <span class="bar-label">{{ "ROUTE_REPORT.SUMMARY.DURATION.PLANNED" | translate }}</span>
          </div>
        </div>
        <div class="bar-value">
          {{ (resumo$ | async)!.planejado.tempo }}
        </div>
      </div>
      <!-- Realizado -->
      <div class="bar-row realizado">
        <div class="bar-container">
          <div class="bar realizado-bar" [ngStyle]="{ width: duracaoExecutado }">
            <span class="bar-label">{{ "ROUTE_REPORT.SUMMARY.DURATION.CARRIED_OUT" | translate }}</span>
          </div>
        </div>
        <div class="bar-value">
          {{ (resumo$ | async)!.executado.tempo }}
        </div>
      </div>
    </div>
    <ng-template #skeletonDuracao>
      <div class="bars">
        <ngx-skeleton-loader [theme]="themeLoader"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="themeLoader"></ngx-skeleton-loader>
      </div>
    </ng-template>
  </div>

  <!-- DISTÂNCIA -->
  <div class="indicador distancia">
    <div class="indicador-text">
      {{ "ROUTE_REPORT.SUMMARY.DISTANCE.DISTANCE" | translate }}
      <mat-icon
        [inline]="true"
        matTooltipPosition="right"
        [matTooltip]="'ROUTE_REPORT.SUMMARY.DISTANCE.' + mensagemRastreamento | translate">
        help
      </mat-icon>
    </div>
    <div class="bars" *ngIf="loaded; else skeletonDistancia">
      <!-- Planejado -->
      <div class="bar-row">
        <div class="bar-container">
          <div class="bar planejado-bar" [ngStyle]="{ width: distanciaPlanejado }">
            <span class="bar-label">{{ "ROUTE_REPORT.SUMMARY.DISTANCE.PLANNED" | translate }}</span>
          </div>
        </div>
        <div class="bar-value">
          {{ (resumo$ | async)!.planejado.distancia | number : "1.2-2" }} km
        </div>
      </div>
      <!-- Realizado -->
      <div class="bar-row realizado">
        <div class="bar-container">
          <div class="bar realizado-bar" [ngStyle]="{ width: distanciaExecutado }">
            <span class="bar-label">{{ "ROUTE_REPORT.SUMMARY.DISTANCE.CARRIED_OUT" | translate }}</span>
          </div>
        </div>
        <div class="bar-value">
          {{ (resumo$ | async)!.executado.distancia | number : "1.2-2" }} km
        </div>
      </div>
    </div>
    <ng-template #skeletonDistancia>
      <div class="bars">
        <ngx-skeleton-loader [theme]="themeLoader"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="themeLoader"></ngx-skeleton-loader>
      </div>
    </ng-template>
  </div>

  <!-- VISITAS -->
  <div class="indicador visitas">
    <div class="indicador-text">
      {{ "ROUTE_REPORT.SUMMARY.VISITS.VISITS" | translate }}
    </div>
    <div class="bars" *ngIf="loaded; else skeletonVisitas">
      <!-- Planejado -->
      <div class="bar-row">
        <div class="bar-container">
          <div class="bar planejado-bar" [ngStyle]="{ width: visitasPlanejado }">
            <span class="bar-label">{{ "ROUTE_REPORT.SUMMARY.VISITS.PLANNED" | translate }}</span>
          </div>
        </div>
        <div class="bar-value">
          {{ (resumo$ | async)!.planejado.visitas }}
        </div>
      </div>
      <!-- Realizado -->
      <div class="bar-row realizado">
        <div class="bar-container">
          <div class="bar realizado-bar" [ngStyle]="{ width: visitasExecutado }">
            <span class="bar-label">{{ "ROUTE_REPORT.SUMMARY.VISITS.CARRIED_OUT" | translate }}</span>
          </div>
        </div>
        <div class="bar-value">
          {{ (resumo$ | async)!.executado.visitas }}
        </div>
      </div>
    </div>
    <ng-template #skeletonVisitas>
      <div class="bars">
        <ngx-skeleton-loader [theme]="themeLoader"></ngx-skeleton-loader>
        <ngx-skeleton-loader [theme]="themeLoader"></ngx-skeleton-loader>
      </div>
    </ng-template>
  </div>
</div>
